module.exports = "/_next/static/images/15afc52695c02dc77e986641217178de-slide-2-large.png";